import React from "react";
import { NavLink } from "react-router-dom";
import "../styles/page.css"

function PageNotFound() {
  return (
    <div>
      <div class="container text-center mt-5 mukto">
        <h1 class="text-white likha"><span>404</span></h1>
        <p class="text-white fs-4">Page Not Found!</p>
        <p class="text-white fs-5">
          Oops! The page you are looking for might be in another universe.
        </p>
        <p className="text-white fs-5">Please Try Again!</p>
        <NavLink className="mt-4 btn btn-outline-light"to="/"> Go Back to Home</NavLink>
      </div>
    </div>
  );
}

export default PageNotFound;
